export const findColorFromCombinations = (options, colorReferances) => {
  const foundColors = []
  // If there are colors at engine level, use those, otherwise fall back to
  // ones at grade level
  const matchRef = (ref) => {
    for (const combination of colorReferances) {
      if (ref === combination.colorRef) return combination
    }
  }
  const level = options.engine.colors.length > 0 ? "engine" : "grade"
  for (const color of options[level].colors) {
    if (!color.ref) {
      throw new Error("Color ref should not be null.")
    }
    const match = matchRef(color.ref)
    if (match) {
      foundColors.push(Object.assign(color, {
        children: match.children,
        default: match.default
      }))
    }
  }
  return foundColors
}

export const findInteriorsFromCombinations = (options, interiorReferences) => {
  const foundInteriors = []
  for (const interiorReference of interiorReferences) {
    for (const interiorDesign of options.grade.interiorDesigns) {
      if (!interiorDesign.ref) {
        throw new Error("Grade level interiorDesign ref should not be null.")
      }
      if (interiorDesign.ref === interiorReference.interiorDesignRef) {
        foundInteriors.push(Object.assign(interiorDesign, {
          default: interiorReference.default
        }))
      }
    }
  }
  return foundInteriors
}

/** Recursively update options from data tree based on selection
 * @param {Object} newSelection - New selection object.
 * @returns {Object} new options object.
 */
export const parseKoalaData = (data, {
  newSelection,
  stateOptions,
  type
} = {}, colorStepVisited = false) => {
  const configNames = [{
    groupName: "bodyStyles",
    itemName: "bodyStyle"
  },
  {
    groupName: "drivetrains",
    itemName: "drivetrain"
  },
  {
    groupName: "grades",
    itemName: "grade"
  },
  {
    groupName: "transmissions",
    itemName: "transmission"
  },
  {
    groupName: "engines",
    itemName: "engine"
  },
  {
    groupName: "colors",
    itemName: "color"
  },
  {
    groupName: "interiorDesigns",
    itemName: "interiorDesign"
  }
  ]

  const compareNames = [{
    groupName: "bodyStyles",
    itemName: "bodyStyle"
  },
  {
    groupName: "grades",
    itemName: "grade"
  },
  {
    groupName: "engines",
    itemName: "engine"
  }
  ]

  const optionNames = type === "compare" ? compareNames : configNames

  /** Choose item from array based on selection / fallback hierarchy
   * @param {Array} items - Array of objects to select from.
   * @param {Object} selection - New selection object.
   * @returns {Object} selected object.
   */
  const selectItem = (items, selection, itemName) => {
    const compareObjects = (object1, object2) =>
      object1.type === object2.type && object1.name === object2.name
    // Return item if it matches selection
    for (const item of items) {
      if (selection && compareObjects(selection, item)) {
        return item
      }
    }
    // Return item in state if it exists
    if (stateOptions) {
      if (
        selection.type === "grade" &&
        itemName === "color" &&
        !colorStepVisited
      ) {
        // Nothing
      } else {
        for (const item of items) {
          if (stateOptions[item.type] && compareObjects(stateOptions[item.type], item)) {
            return item
          }
        }
      }
    }
    // Return item marked default
    for (const item of items) {
      if (item.default) {
        return item
      }
    }
    // Return first item in array (failsafe)
    return items[0]
  }
  const options = {}
  options.nameplate = data
  const buildStateOptions = (previousItem, optionIndex) => {
    if (typeof optionIndex === "undefined") optionIndex = 0
    const option = optionNames[optionIndex || 0]
    if (!previousItem.children || !previousItem.children.length) return
    if (option.itemName === "color") {
      options[option.groupName] = findColorFromCombinations(options, previousItem.children)
    } else if (option.itemName === "interiorDesign") {
      options[option.groupName] = findInteriorsFromCombinations(options, previousItem.children)
    } else {
      options[option.groupName] = previousItem.children
    }
    options[option.itemName] = selectItem(options[option.groupName], newSelection, option.itemName)
    if (typeof options[option.itemName] === "undefined") {
      throw new Error(`Option name ${option.itemName} does not exist in options.`)
    }
    if (options[option.itemName].type !== option.itemName) {
      throw new Error(`Option type (${options[option.itemName]
        .type}) does not match expected type. (${option.itemName})`)
    }
    buildStateOptions(options[option.itemName], optionIndex + 1)
  }
  try {
    buildStateOptions(data)
  } catch (error) {
    console.warn(error, options)
  }
  return options
}



// WEBPACK FOOTER //
// ./src/utils/koala.js